// extracted by mini-css-extract-plugin
export default {"list":"LlavesLista_list__Z9gxY"};